import { BaseFilterOption } from './types';
import { config as geneConfig } from './gene';
import { config as geneSetsConfig } from './geneSets';
import { config as inFrameConfig } from './inFrame';
import { config as structuralTypeConfig } from './structuralType';
import { config as cancerKnowledgeBaseConfig } from './jaxCKB';
import { config as selectedConfig } from './selected';
import { buildConfig as buildLabReportedSignificanceConfig } from './labReportedSignificance';

const labReportedSignificanceConfig = buildLabReportedSignificanceConfig();

export const structuralVariantOptions: Array<Partial<BaseFilterOption>> = [
  { ...selectedConfig },
  { ...cancerKnowledgeBaseConfig },
  { ...geneSetsConfig },
  { ...geneConfig },
  { ...structuralTypeConfig },
  { ...inFrameConfig },
  { ...labReportedSignificanceConfig },
];
